export default {
  isAuth: state => state.isAuth,
};
